export default __webpack_public_path__ + "static/media/jiraiya.8ffd7cc6.png";